import { useState, useEffect, useContext } from "react";
import { Card, Col, Row, Table, Form, Modal, Button, Spinner} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import Select from "react-select";
import NotyfContext from "../../contexts/NotyfContext";
import { UserSettingsContext } from "../../contexts/UserSettingsContext";
import authenticatedFetch from "../../utils/fetch"
import LastRun from "../../utils/LastRun";

const ProviderSelect = ({ handleProviderChanged, selectedProviders}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        authenticatedFetch({
            path: "provider/revenueteam?includeEndDated=false",
                successHandler: function(result) {
                setIsLoaded(true);
                setData(result);
            },
            errorHandler: function(error) {
                setIsLoaded(true);
                setError(error);
            }
        });
    }, [])

    const options = data.map((provider) => {
        return {value: provider.id, label: provider.lastName + ", " + provider.firstName + (provider.middleName ? " " + provider.middleName : "")};
    });

    if (!isLoaded)
    {
      return (<Form.Select style={{width: "350px", height: "38px"}} disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select style={{width: "350px", height: "38px"}} disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
        return (
            <div style={{width: "350px"}}>
                <Select
                options={options}
                onChange={(selectedProviders) => {
                    handleProviderChanged(selectedProviders);
                }}
                value={selectedProviders}
                placeholder="All"
                isMulti
                theme={(theme) => ({
                  ...theme,
                  colors: {
                  ...theme.colors,
                    primary50: '#DEF2F1',
                    primary25: '#DEF2F1',
                    primary: '#3AAFA9',
                  },
                })}
                />
            </div>
        )
    }
}

const ProviderIAHMPRosterModal = ({ show, onClose, runSuccess}) => {
  const [providerIds, setProviderIds] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);

  const [isExporting, setIsExporting] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleProviderChanged = (providers) => {
      setSelectedProviders(providers);

      let newProviderIds = []
      for (var i=0; i<providers.length; i++)
      {
          newProviderIds.push(providers[i].value);
      }

      setProviderIds(newProviderIds);
  }

  const handleExportClicked = (e) => {
      e.preventDefault();
      setIsExporting(true);

      authenticatedFetch({
        method: "POST",
        path:  "report/provideriahmproster",
        requestData: {
          providerIds: providerIds
        },
        successHandler: function(result) {
          window.open(result.url);
          setIsExporting(false);

          runSuccess("provideriahmproster")
          onClose();
        },
        errorHandler: function(error) {
          setIsExporting(false);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
  }

  return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Configure Report | IAHMP Roster</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <tbody>
              <tr>
                  <td>Provider(s):</td>
                  <td><ProviderSelect handleProviderChanged={handleProviderChanged} selectedProviders={selectedProviders}/></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
        {isExporting ?
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '15px', marginTop: '11px', marginBottom: '11px'}}/>
          :
          <>
            <Button className="btn-secondary" onClick={onClose}>Close</Button>
            <Button onClick={(e) => {handleExportClicked(e)}}>Run Report</Button>
          </>
          }
        </Modal.Footer>
      </Modal>
  );
}

const ProviderAzAhpNonDelegatedGroupRosterModal = ({ show, onClose, runSuccess}) => {
  const [providerIds, setProviderIds] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);

  const [isExporting, setIsExporting] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleProviderChanged = (providers, e) => {
      setSelectedProviders(providers);

      let newProviderIds = []
      for (var i=0; i<providers.length; i++)
      {
          newProviderIds.push(providers[i].value);
      }

      setProviderIds(newProviderIds);
  }

  const handleExportClicked = (e) => {
      e.preventDefault();
      setIsExporting(true);

      authenticatedFetch({
        method: "POST",
        path:  "report/providerazahpnondelegatedgrouproster",
        requestData: {
          providerIds: providerIds
        },
        successHandler: function(result) {
          window.open(result.url);
          setIsExporting(false);

          runSuccess("providerazahpnondelegatedgrouproster")
          onClose();
        },
        errorHandler: function(error) {
          setIsExporting(false);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
  }

  return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Configure Report | AzAHP Non Delegated Group Roster</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <tbody>
              <tr>
                  <td>Provider(s):</td>
                  <td><ProviderSelect handleProviderChanged={handleProviderChanged} selectedProviders={selectedProviders}/></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
        {isExporting ?
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '15px', marginTop: '11px', marginBottom: '11px'}}/>
          :
          <>
            <Button className="btn-secondary" onClick={onClose}>Close</Button>
            <Button onClick={(e) => {handleExportClicked(e)}}>Run Report</Button>
          </>
          }
        </Modal.Footer>
      </Modal>
  );
}

const ProviderHumanaRosterModal = ({ show, onClose, runSuccess}) => {
  const [providerIds, setProviderIds] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);

  const [isExporting, setIsExporting] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleProviderChanged = (providers, e) => {
      setSelectedProviders(providers);

      let newProviderIds = []
      for (var i=0; i<providers.length; i++)
      {
          newProviderIds.push(providers[i].value);
      }

      setProviderIds(newProviderIds);
  }

  const handleExportClicked = (e) => {
      e.preventDefault();
      setIsExporting(true);

      authenticatedFetch({
        method: "POST",
        path:  "report/provideridhumanaroster",
        requestData: {
          providerIds: providerIds
        },
        successHandler: function(result) {
          window.open(result.url);
          setIsExporting(false);

          runSuccess("provideridhumanaroster")
          onClose();
        },
        errorHandler: function(error) {
          setIsExporting(false);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
  }

  return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Configure Report | Humana Preferred Standard Roster</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <tbody>
              <tr>
                  <td>Provider(s):</td>
                  <td><ProviderSelect handleProviderChanged={handleProviderChanged} selectedProviders={selectedProviders}/></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
        {isExporting ?
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '15px', marginTop: '11px', marginBottom: '11px'}}/>
          :
          <>
            <Button className="btn-secondary" onClick={onClose}>Close</Button>
            <Button onClick={(e) => {handleExportClicked(e)}}>Run Report</Button>
          </>
          }
        </Modal.Footer>
      </Modal>
  );
}

const ProviderAzImperialRosterModal = ({ show, onClose, runSuccess}) => {
  const [providerIds, setProviderIds] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);

  const [isExporting, setIsExporting] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleProviderChanged = (providers, e) => {
      setSelectedProviders(providers);

      let newProviderIds = []
      for (var i=0; i<providers.length; i++)
      {
          newProviderIds.push(providers[i].value);
      }

      setProviderIds(newProviderIds);
  }

  const handleExportClicked = (e) => {
      e.preventDefault();
      setIsExporting(true);

      authenticatedFetch({
        method: "POST",
        path:  "report/providerazimperialroster",
        requestData: {
          providerIds: providerIds
        },
        successHandler: function(result) {
          window.open(result.url);
          setIsExporting(false);

          runSuccess("providerazimperialroster")
          onClose();
        },
        errorHandler: function(error) {
          setIsExporting(false);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
  }

  return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Configure Report | Imperial Health Roster</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <tbody>
              <tr>
                  <td>Provider(s):</td>
                  <td><ProviderSelect handleProviderChanged={handleProviderChanged} selectedProviders={selectedProviders}/></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
        {isExporting ?
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '15px', marginTop: '11px', marginBottom: '11px'}}/>
          :
          <>
            <Button className="btn-secondary" onClick={onClose}>Close</Button>
            <Button onClick={(e) => {handleExportClicked(e)}}>Run Report</Button>
          </>
          }
        </Modal.Footer>
      </Modal>
  );
}

const ProviderAzAntidoteRosterModal = ({ show, onClose, runSuccess}) => {
  const [providerIds, setProviderIds] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);

  const [isExporting, setIsExporting] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleProviderChanged = (providers, e) => {
      setSelectedProviders(providers);

      let newProviderIds = []
      for (var i=0; i<providers.length; i++)
      {
          newProviderIds.push(providers[i].value);
      }

      setProviderIds(newProviderIds);
  }

  const handleExportClicked = (e) => {
      e.preventDefault();
      setIsExporting(true);

      authenticatedFetch({
        method: "POST",
        path:  "report/providerazantidoteroster",
        requestData: {
          providerIds: providerIds
        },
        successHandler: function(result) {
          window.open(result.url);
          setIsExporting(false);

          runSuccess("providerazantidoteroster")
          onClose();
        },
        errorHandler: function(error) {
          setIsExporting(false);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
  }

  return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Configure Report | Antidote Provider Roster</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <tbody>
              <tr>
                  <td>Provider(s):</td>
                  <td><ProviderSelect handleProviderChanged={handleProviderChanged} selectedProviders={selectedProviders}/></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
        {isExporting ?
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '15px', marginTop: '11px', marginBottom: '11px'}}/>
          :
          <>
            <Button className="btn-secondary" onClick={onClose}>Close</Button>
            <Button onClick={(e) => {handleExportClicked(e)}}>Run Report</Button>
          </>
          }
        </Modal.Footer>
      </Modal>
  );
}

const RosterList = () => {
    const [showProviderIAHMPRosterModal, setShowProviderIAHMPRosterModal] = useState(false);
    const [showProviderAzAhpNonDelegatedGroupRosterModal, setShowProviderAzAhpNonDelegatedGroupRosterModal] = useState(false);
    const [showProviderHumanaRosterModal, setShowProviderHumanaRosterModal] = useState(false);
    const [showProviderAzImperialRosterModal, setShowProviderAzImperialRosterModal] = useState(false);
    const [showProviderAzAntidoteRosterModal, setShowProviderAzAntidoteRosterModal] = useState(false);

    const [lastRunRefresh, setLastRunRefresh] = useState(0);

    const { isH3Admin, authorities } = useContext(UserSettingsContext);

    const runSuccess = (e) => {
      setLastRunRefresh(lastRunRefresh + 1);
    }

    return (
      <Card>
        <Card.Header style={{marginBottom: '-15px'}}>
            <Card.Title>
            Rosters
            </Card.Title>
          </Card.Header>
        <Table striped hover>
          <thead>
            <tr>
              <td>State</td>
              <td>Name</td>
              <td>Last Run</td>
            </tr>
          </thead>
          <tbody>
            {(isH3Admin || authorities.includes("PROVIDER_SENSITIVE_DETAILS_VIEW") || authorities.includes("PROVIDER_SENSITIVE_DETAILS_EDIT")) ?
            <tr style={{cursor:"pointer"}} onClick={(e) => {setShowProviderAzAntidoteRosterModal(true)}}>
                <td>AZ</td>
                <td><a href="#" onClick={(e) => e.preventDefault()}>Antidote Provider Roster</a></td>
                <td><LastRun reportType="providerazantidoteroster" refresh={lastRunRefresh}/></td>
            </tr>
             : <></>
            }
            {(isH3Admin || authorities.includes("PROVIDER_SENSITIVE_DETAILS_VIEW") || authorities.includes("PROVIDER_SENSITIVE_DETAILS_EDIT")) ?
            <tr style={{cursor:"pointer"}} onClick={(e) => {setShowProviderAzAhpNonDelegatedGroupRosterModal(true)}}>
                <td>AZ</td>
                <td><a href="#" onClick={(e) => e.preventDefault()}>AzAHP Non Delegated Group Roster</a></td>
                <td><LastRun reportType="providerazahpnondelegatedgrouproster" refresh={lastRunRefresh}/></td>
            </tr>
             : <></>
            }
            {(isH3Admin || authorities.includes("PROVIDER_SENSITIVE_DETAILS_VIEW") || authorities.includes("PROVIDER_SENSITIVE_DETAILS_EDIT")) ?
            <tr style={{cursor:"pointer"}} onClick={(e) => {setShowProviderAzImperialRosterModal(true)}}>
                <td>AZ</td>
                <td><a href="#" onClick={(e) => e.preventDefault()}>Imperial Health Roster</a></td>
                <td><LastRun reportType="providerazimperialroster" refresh={lastRunRefresh}/></td>
            </tr>
             : <></>
            }
            {(isH3Admin || authorities.includes("PROVIDER_SENSITIVE_DETAILS_VIEW") || authorities.includes("PROVIDER_SENSITIVE_DETAILS_EDIT")) ?
            <tr style={{cursor:"pointer"}} onClick={(e) => {setShowProviderHumanaRosterModal(true)}}>
                <td>ID</td>
                <td><a href="#" onClick={(e) => e.preventDefault()}>Humana Preferred Standard Roster</a></td>
                <td><LastRun reportType="provideridhumanaroster" refresh={lastRunRefresh}/></td>
            </tr>
             : <></>
            }
            {(isH3Admin || authorities.includes("PROVIDER_SENSITIVE_DETAILS_VIEW") || authorities.includes("PROVIDER_SENSITIVE_DETAILS_EDIT")) ?
            <tr style={{cursor:"pointer"}} onClick={(e) => {setShowProviderIAHMPRosterModal(true)}}>
                <td>(Multi-State)</td>
                <td><a href="#" onClick={(e) => e.preventDefault()}>IAMHP Roster</a></td>
                <td><LastRun reportType="provideriahmproster" refresh={lastRunRefresh}/></td>
            </tr>
             : <></>
            }
          </tbody>
        </Table>

        <ProviderIAHMPRosterModal show={showProviderIAHMPRosterModal} onClose={() => setShowProviderIAHMPRosterModal(false)} runSuccess={runSuccess} />
        <ProviderAzAhpNonDelegatedGroupRosterModal show={showProviderAzAhpNonDelegatedGroupRosterModal} onClose={() => setShowProviderAzAhpNonDelegatedGroupRosterModal(false)} runSuccess={runSuccess} />
        <ProviderHumanaRosterModal show={showProviderHumanaRosterModal} onClose={() => setShowProviderHumanaRosterModal(false)} runSuccess={runSuccess} />
        <ProviderAzImperialRosterModal show={showProviderAzImperialRosterModal} onClose={() => setShowProviderAzImperialRosterModal(false)} runSuccess={runSuccess} />
        <ProviderAzAntidoteRosterModal show={showProviderAzAntidoteRosterModal} onClose={() => setShowProviderAzAntidoteRosterModal(false)} runSuccess={runSuccess} />
      </Card>
    )
  };

const Rosters = () => {

    return (
      <Row>
        <Helmet title="Rosters"/>
        <Col lg="12">
          <RosterList />
        </Col>
      </Row>
    )
  };

export default Rosters;
